export default "__VITE_ASSET__g9uP56et__"